import Axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import useStorage from '../hooks/useStorage';

const AxiosConfig: AxiosRequestConfig = {
    withCredentials: true,
    timeout: 30000,
    baseURL: '/api',
    headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json, application/octet-stream',
    },
};

const { getToken, setToken, removeToken, getSsoMode } = useStorage();

const authApi = Axios.create(AxiosConfig);
authApi.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    config.headers['Authorization'] = getToken();

    // in the case of FormData or Blob, remove the default header 'Content-Type: application/json', so that Axio can add
    // content-type header and format the request body automatically, otherwise the request body might be in unexpected
    // format when sent out, therefore not handled properly in backend
    if (config.data instanceof FormData || config.data instanceof Blob) {
        delete config.headers['Content-Type'];
    }

    return config;
});
authApi.interceptors.response.use(response => {
    if (response && response.headers && response.headers['refreshtoken']) {
        setToken(response.headers['refreshtoken']);
    } else if (response && response.headers && response.headers['expiredssotoken'] === 'true') {
        const refreshTokenURI = response.headers['refreshtokenuri'];
        window.location.href = refreshTokenURI;
        removeToken();
    }
    return response;
});

export const getAuthApi = () => authApi;
export const getApi = () => Axios.create({ ...AxiosConfig, withCredentials: false });

export default AxiosConfig;
